import html2canvas from 'html2canvas-pro';
import jsPDF from 'jspdf';
import { PX_TO_MM } from '@/shared/utils/paperSizes';


const CAPTURE_SCALE = 2;

const afterPaint = () =>
  new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });


export async function downloadNodeAsPdf(
  node: HTMLElement | null | undefined,
  fileName: string,
): Promise<void> {
  if (!node) throw new Error('There is nothing to export yet.');

  const pages = Array.from(node.querySelectorAll<HTMLElement>('.pf-page'));
  const sheets = pages.length ? pages : [node];

  let pdf: jsPDF | null = null;

  for (const sheet of sheets) {
    await afterPaint();

    const canvas = await html2canvas(sheet, {
      scale: CAPTURE_SCALE,
      useCORS: true,
      backgroundColor: '#ffffff',
      logging: false,
    });

    const widthMm =
      (sheet.offsetWidth || canvas.width / CAPTURE_SCALE) * PX_TO_MM;
    const heightMm =
      (sheet.offsetHeight || canvas.height / CAPTURE_SCALE) * PX_TO_MM;

    const orientation = widthMm > heightMm ? 'landscape' : 'portrait';

    if (!pdf) {
      pdf = new jsPDF({
        unit: 'mm',
        format: [widthMm, heightMm],
        orientation,
        compress: true,
      });
    } else {
      pdf.addPage([widthMm, heightMm], orientation);
    }

    pdf.addImage(
      canvas.toDataURL('image/png'),
      'PNG',
      0,
      0,
      widthMm,
      heightMm,
    );
  }

  pdf?.save(`${fileName}.pdf`);
}
